import { Button } from "@client/shadcn/ui/button";
import { Card, CardDescription, CardFooter, CardHeader, CardTitle } from "@client/shadcn/ui/card";
import { ChevronRight } from "lucide-react";
import React from "react";

interface Props {
    className?: string;
    title: string;
    description: string;
    href: string;
}

export const FeatureCard = (props: Props) => {
    return (
        <a href={props.href}>
            <Card>
                <CardHeader>
                    <CardTitle>{props.title}</CardTitle>
                    <CardDescription>{props.description}</CardDescription>
                </CardHeader>
                <CardFooter className="justify-end">
                    <Button variant="outline" size="icon" className="cursor-pointer">
                        <ChevronRight />
                    </Button>
                </CardFooter>
            </Card>
        </a>
    );
};
